import { JobVM } from 'system/view-models/batch-managment/job-vm';
import { BatchUploadFormType } from './types';
export interface GestioneBatchUploadFileTpe {
  uploadFile: string | ArrayBuffer | null;
  fileName?: string;
  jobName?: string;
  nmCartellaInput?: string;
}

export const getJobName = (
  batchName?: JobVM | null,
  batchDescription?: JobVM | null
): string | undefined => {
  return batchName ? batchName?.name : batchDescription ? batchDescription?.name : undefined;
};

export const transformRequestGestioneBatchUploadFile = (
  values: BatchUploadFormType
): GestioneBatchUploadFileTpe => {
  return {
    uploadFile: values?.file?.fileBaseTo64,
    fileName: values?.file?.file?.name,
    jobName: getJobName(values?.batchName, values?.batchDescription),
    nmCartellaInput: values?.folderName,
  };
};
